import * as css from 'css/exports.module.scss';

import './FieldScopeHeader.scss';

import { SonarTagManager } from '@ui/tags';
import { Space } from 'antd';

import { PeriscopeSfFieldSummary, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback, useEffect } from 'react';
import { SonarRecordNameSection, SonarRecordReferences, SonarRecordRelationships } from '@ui/records';
import { usePeriscopeActions, useSonarObjectReference } from '@hooks';

export interface FieldScopeHeaderProps {
	data: PeriscopeSfFieldSummary;
	index: number;
}

export const FieldScopeHeader: React.FC<FieldScopeHeaderProps> = ({ data, index }) => {
	const { isActive, relatedCounts, sonarObjectId, versionNumber } = data;

	const {
		linkedIntegrations,
		internalName,
		parentDisplayName,
		parentInternalName,
		parentSonarObjectId,
		rawSalesforceType
	} = useSonarObjectReference(sonarObjectId);

	const { openPeriscope, updatePeriscope } = usePeriscopeActions();

	useEffect(() => {
		updatePeriscope({
			periscopeIndex: index,
			subType: data.type ?? rawSalesforceType ?? ''
		});
	}, [ updatePeriscope, data.type, rawSalesforceType, index ]);

	const handleParentClick = useCallback(() => {
		openPeriscope({
			id: parentSonarObjectId ?? 0,
			name: parentDisplayName ?? '',
			openLeft: true,
			openedFromIndex: index,
			type: SonarObjectType.SalesforceEntity
		});
	}, [ openPeriscope, parentSonarObjectId, parentDisplayName, index ]);

	return (
		<div className='field-scope-header'>
			<Space size={ Number(css.size8) }>
				<SonarRecordNameSection
					isActive={ isActive }
					name={ internalName ?? '' }
					onClickParent={ handleParentClick }
					parentName={ parentInternalName ?? '' }
					removeBold
					showArrow
					versionNumber={ versionNumber } />
				<SonarRecordRelationships relatedOrgs={ linkedIntegrations } />
			</Space>
			<div className='record-references'>
				<SonarRecordReferences
					parentName={ parentDisplayName ?? '' }
					relatedCounts={ relatedCounts }
					sonarObjectId={ sonarObjectId } />
				<SonarTagManager sonarObjectId={ sonarObjectId } />
			</div>
		</div>
	);
};
